import React from 'react'

const CredentialCard = ({...r}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 48 48" {...r}>
      <path
        fill="#00033A"
        d="M34.422 8.322a3.375 3.375 0 00-3.376-3.375H14.934a3.376 3.376 0 00-3.376 3.375L11.54 15.5h1.329l.024-7.193a2.05 2.05 0 012.05-2.047l1.864.002c.394 0 .54 0 .564.5.023.518.38.836.863.988.081.025 2.43.04 4.78.042h1c1.974-.002 3.71-.013 3.78-.034.483-.152.84-.47.865-.987.024-.5.17-.5.563-.5h1.848c1.13.002 2.047.92 2.047 2.05L33.1 12.5h1.31l.011-4.178zM30.95 47.848a3.375 3.375 0 003.376-3.375L34.359 32h-1.324l-.043 12.44a2.046 2.046 0 01-2.048 2.046l-16.127-.012a2.049 2.049 0 01-2.047-2.049L12.802 35h-1.315l-.025 9.473a3.377 3.377 0 003.377 3.375h16.11z"
      ></path>
      <path
        fill="#00033A"
        fillRule="evenodd"
        d="M27.422 39.058l-1.026-1.025-3.338 3.33-3.338-3.33-1.025 1.025 4.363 4.364 4.364-4.364z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#126FFF"
        strokeWidth="1.6"
        d="M31.554 12.434L11.45 15.711c-2.157.352-3.64 2.345-3.307 4.442l1.899 11.936c.301 1.902 1.996 3.247 3.917 3.22.198-.003.399-.02.6-.053l20.106-3.277c2.156-.351 3.64-2.345 3.305-4.443l-1.897-11.935c-.303-1.903-1.997-3.248-3.918-3.22-.2.002-.4.02-.6.053z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#126FFF"
        fillRule="evenodd"
        d="M13.237 21.973a1.454 1.454 0 11-1.24-2.63 1.454 1.454 0 011.24 2.63zm21.739 5.149a1.454 1.454 0 11-2.631 1.24 1.454 1.454 0 012.63-1.24z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#126FFF"
        fillRule="evenodd"
        stroke="#126FFF"
        strokeWidth="0.5"
        d="M27.384 24.394a.358.358 0 01-.139-.005 4.161 4.161 0 01-2.895-2.464 4.126 4.126 0 01.007-3.179 4.121 4.121 0 012.253-2.243 4.124 4.124 0 013.18.007 4.124 4.124 0 012.242 2.253.362.362 0 11-.672.277 3.404 3.404 0 00-1.851-1.86 3.409 3.409 0 00-2.622-.005 3.405 3.405 0 00-1.859 1.85 3.405 3.405 0 00-.005 2.624 3.436 3.436 0 002.387 2.032.364.364 0 01-.026.713z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#126FFF"
        fillRule="evenodd"
        stroke="#126FFF"
        strokeWidth="0.5"
        d="M34.051 21.121l-5.194.823c-.153.024-.302-.117-.333-.316-.032-.198.067-.378.219-.402l5.195-.823c.152-.024.301.117.332.315.032.198-.066.379-.219.403z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default CredentialCard